import React, { useEffect, useState } from "react";
import "./app.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Evenements from "../Evenements/Evenements";
import Actualites from "Pages/Actualites/Actualites";
import Offres from "../Offres/Offres";
import Groupes from "../Groupes/Groupes";
import Annuaire from "Pages/Annuaire/Annuaire";
import Accueil from "../Accueil/Accueil";
import Profil from "../Profil/Profil";
import OffreDetail from "Components/Offres/Offre/OffreDetail/OffreDetail";
import ProfilEdit from "Pages/Profil/ProfilEdit/ProfilEdit";
import EntrepriseDetail from "Components/Annuaire/AnnuaireEntreprise/EntrepriseDetail/EntrepriseDetail";
import CVTheque from "Pages/CVTheque/CVTheque";
import Error401 from "Components/Error/Error401/Error401";
import ProfilShow from "Pages/Profil/ProfilShow/ProfilShow";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import EvenementDetail from "Components/Evenements/EvenementDetail/EvenementDetail";
import ActualiteDetail from "Components/Actualites/ActualiteDetail/ActualiteDetail";
import Universites from "Pages/Universites/Universites";
import Entreprises from "Pages/Entreprises/Entreprises";
import Parametrage from "Pages/Parametrage/Parametrage";
import Contact from "Pages/Footer/Contact/Contact";
import ValidateAccount from "../../Components/ValidateAccont/ValidateAccount";
import { ToastContainer } from "react-toastify";
// import Aide from "Pages/Footer/Aide/Aide";
// import Accessibilite from "Pages/Footer/Accessibilite/Accessibilite";
// import GestionCookies from "Pages/Footer/GestionCookies/GestionCookies";
import MentionsLegales from "Pages/Footer/MentionsLegales/MentionsLegales";
import PlanDuSite from "Pages/Footer/PlanDuSite/PlanDuSite";
import { fetchGet, useFetchGet } from "Services/api";
import { updateAdmin } from "Redux/Actions/adminActions";
import GroupeCardEventDetails from "Components/Groupes/GroupeCard/GroupeCardEvent/GroupeCardEventDetails/GroupeCardEventDetails";
import { getCookie } from "Services/functions";
import { updateAuth } from "Redux/Actions/authActions";
import Messages from "Pages/Messages/Messages";
import { addLocale, locale } from "primereact/api";
import { getFrenchLocale } from "Components/Stats/Data/Const";
import { checkTokenValidity, fetchUser, processToken } from "Services/auth";
import axios from "axios";
import ModalCharte from "Components/Modal/ModalCharte/ModalCharte";
import Loader from "Components/Loader/loader";
import { Toast } from "primereact/toast";
import { getMatomoConfig } from "Services/matomo";

const CHECK_EXPIRATION_TIME_INTERVAL = 20000;

/**
 * Composant mère dont dépendent tous les autres composants qui seront affichés
 */
function App(props) {
  // Utilisation du locale fr pour les components date + heures primeReact
  addLocale("fr", getFrenchLocale().fr);
  locale("fr");
  const [visibleModalCharte, setvisibleModalCharte] = useState(false);
  //? Récupération des données de la gestion éditoriale
  const gestionEditUniv = useFetchGet("/editorial_managements");
  const gestionEditNexus = useFetchGet(
    "/editorial_managements",
    null,
    null,
    "nexus"
  );

  const [verifyUser, setVerifyUser] = useState(false);
  const [displayApp, setDisplayApp] = useState(false);

  const interval = React.useRef(null);

  //? Récupération de la configuration de Matomo
  //? Ce hook est exécuté à chaque fois (chaque page) pour le tracking
  useEffect(() => {
    const matomoConfig = getMatomoConfig();

    if (matomoConfig) {
      matomoConfig();
    }
  }, []);

  const toast = React.useRef(null);
  useEffect(() => {
    props.handleAuth({
      toast: toast,
    });
  }, [toast]);
  /**
   * Hook qui vérifie si le token est valide, exécuté à chaque fois que le token change
   * Sur un intervalle de 20 secondes
   */
  useEffect(async () => {
    clearInterval(interval.current);
    interval.current = setInterval(async () => {
      const token = props.auth.token;
      if (!token) return;
      // On récupère le token
      if (!props.auth.token) return;
      const newToken = await processToken(props.auth.token);

      // Si token n'est pas null et n'est pas une promise on met à jour l'état d'authentification
      if (newToken != null && !newToken?.then) {
        props.handleAuth({
          token: newToken,
        });
      }
    }, CHECK_EXPIRATION_TIME_INTERVAL);
    return () => {
      clearInterval(interval.current);
    };
  }, [props.auth.token]);

  /**
   * It checks for the presence of a cookie every second for 2 seconds.
   * If the cookie is found, it tries to authenticate the user.
   * @returns A function that clears the interval.
   */
  const checkForCookie = () => {
    let counter = 0;
    let isAuthenticating = false;
    let intervalId = null;

    const checkFunction = async () => {
      const conditions =
        counter > 3 ||
        (props.auth.token &&
          props.auth.isConnected &&
          props.auth.userConnected);
      if (conditions) {
        clearInterval(intervalId);
        setVerifyUser(true);
        return;
      }

      const cookie = getCookie("t");
      if (!cookie) counter++;

      if (!isAuthenticating) {
        isAuthenticating = true;
        const check = await authenticateUser();
        if (check) {
          setVerifyUser(true);
          clearInterval(intervalId);
          counter++;
        }
        isAuthenticating = false;
      }
    };

    clearInterval(intervalId);
    setTimeout(async () => {
      checkFunction();
      intervalId = setInterval(checkFunction, 1000);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  };

  /**
   * Vérifie si l'utilisateur est connecté, en fonction du cookie
   */
  useEffect(async () => {
    if (
      !process.env?.REACT_APP_IS_NEXUS ||
      process.env?.REACT_APP_IS_NEXUS == "false"
    ) {
      await getUnivConnected();
      checkForCookie();
    } else setVerifyUser(true);
  }, []);

  useEffect(() => {
    if (gestionEditNexus.loaded) {
      props.handleAdmin({
        editManagementNexus: gestionEditNexus.data,
      });
    }
  }, [gestionEditNexus.loaded]);

  useEffect(() => {
    if (gestionEditUniv.loaded) {
      if (process.env.REACT_APP_IS_NEXUS === "true")
        props.handleAdmin({
          editManagementNexus: gestionEditUniv.data,
        });
      else
        props.handleAdmin({
          editManagement: gestionEditUniv.data,
        });
    }
  }, [gestionEditUniv.loaded]);

  useEffect(async () => {
    if (props.auth.isConnected) {
      const gestionEditBoolean = await fetchGet(
        "/editorial_management_booleans"
      );
      props.handleAdmin({
        editManagementBoolean: gestionEditBoolean,
      });
    }
  }, [props.auth.isConnected]);

  const removeUserData = () => {
    props.handleAuth({
      token: null,
      userConnected: null,
      isConnected: false,
      universityConnected: {},
      isAdmin: false,
      isCreator: false,
      isValidator: false,
    });
    // redirection vers la page shibboleth car l'utilisateur n'est pas connecté (uniquement en prod)
    if (
      process.env.REACT_APP_IS_NEXUS === "false" &&
      process.env.REACT_APP_ENV === "production"
    )
      window.location.href = process.env.REACT_APP_SHIBBO_URL_LOGIN;
    else setDisplayApp(true);
  };

  const chartSigned = async () => {
    await getUnivConnected();
    const url = `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}`;

    axios.put(
      url,
      { charteSigned: true },
      {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      }
    );
  };

  const verifiyCharte = async (user) => {
    if (!user.charteSigned) {
      setvisibleModalCharte(true);
    }
  };

  // Fonction pour remplir les données de l'user dans le store
  const fillUser = (user, token) => {
    props.handleAuth({
      token: token,
      userConnected: user,
      isConnected: true,
      isAdmin: user.userRoles.some(
        (role) => role.roleName == "ROLE_ADMIN_DU_PORTAIL"
      ),
      isCreator: user.userRoles.some((role) =>
        role.roleName.includes("REDACTEUR_ACTU")
      ),
      isValidator: user.userRoles.some((role) =>
        role.roleName.includes("VALIDATEUR_OFFRE")
      ),
    });
  };

  // Fonction pour récupérer les données de l'université connectée
  const getUnivConnected = async () => {
    if (process.env.REACT_APP_IS_NEXUS === "true") return;
    axios
      .get(`${process.env.REACT_APP_BASE_URL_API}/this_university`, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .catch(() => {})
      .then((response) => {
        props.handleAuth({
          universityConnected: response?.data,
        });
      });
  };

  const authenticateUser = async () => {
    // On check les cookies pour voir s'il y a un token / refresh token
    let token = getCookie("t");
    if (!token) return false;
    let user = null;
    try {
      user = await fetchUser(token);
    } catch (exception) {
      if (axios.isAxiosError(exception)) {
        /** @var AxiosError */
        removeUserData();
        //? 401 = Unauthorized (session expirée ou token invalide...)
        //? Donc on force l'utilisateur à se reconnecter pour recréer une session et un token valide
        if (exception.response.status === 401)
          window.location.href = `${process.env.REACT_APP_BASE_URL_API}/logout`;
      }
      return false;
    }
    if (user) {
      fillUser(user, token);
      await verifiyCharte(user, token);
      return true;
    } else {
      removeUserData();
      return false;
    }
  };

  useEffect(() => {
    if (verifyUser) {
      if (props.auth.isConnected) {
        const isValid = checkTokenValidity(props.auth?.token);
        if (!isValid) removeUserData();
        else setDisplayApp(true);
      } else removeUserData();
    }
  }, [verifyUser]);

  return (
    <>
      {displayApp ? (
        <div
          className="app"
          id="app"
          data-theme={
            props.auth.universityConnected?.slug
              ? props.auth.universityConnected.slug
              : "default"
          }
        >
          <BrowserRouter>
            <Toast ref={toast} />
            <Routes>
              <Route path="/" element={<Accueil />} />
              <Route path="/evenements" element={<Evenements />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/universites" element={<Universites />} />
              <Route path="/espace-recruteurs" element={<Entreprises />} />
              <Route path="/offres" element={<Offres />} />
              <Route path="/groupes" element={<Groupes />} />
              <Route path="/annuaire" element={<Annuaire />} />
              {props.user.isConnected && (
                <Route path="/profil" element={<Profil />} />
              )}
              {props.user.isConnected && (
                <Route path="/messages" element={<Messages />}></Route>
              )}
              <Route path="/parametrage" element={<Parametrage />} />
              <Route path="/profil-edit" element={<ProfilEdit />} />
              <Route path="/profil-show/:id" element={<ProfilShow />} />
              {/* <Route path="/offre-detail/:idOffre" exact></Route> */}
              <Route path={"/offre-detail/:id"} element={<OffreDetail />} />
              <Route path={"/event-detail/:id"} element={<EvenementDetail />} />
              <Route
                path={"/group_event-detail/:id"}
                element={<GroupeCardEventDetails />}
              />
              <Route path={"/actu-detail/:id"} element={<ActualiteDetail />} />
              <Route path="/cvtheque" element={<CVTheque />} />
              <Route
                path="/annuaire/detail/:id"
                element={<EntrepriseDetail />}
              />
              <Route path="/contact" element={<Contact />} />
              {/* <Route path="/aide" element={<Aide />} /> */}
              {/* <Route path="/accessibilite" element={<Accessibilite />} /> */}
              {/* <Route path="/gestion-cookies" element={<GestionCookies />} /> */}
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/plan-du-site" element={<PlanDuSite />} />
              {/* 404 */}
              <Route path="/error401" element={<Error401 />} />
              <Route path="*" element={<Accueil />} />
              <Route path="/validate-account/:token" element={<ValidateAccount />} />
            </Routes>
          </BrowserRouter>
          {visibleModalCharte && (
            <ModalCharte
              visibleModal={visibleModalCharte}
              setVisibleModal={setvisibleModalCharte}
              btnRefuse={() => {
                props.handleAuth({ userConnected: null });
              }}
              btnAction={() => {
                chartSigned();
              }}
            >
              <div className="description">
                <ModalCharte />
              </div>
            </ModalCharte>
          )}
          <ToastContainer
              position="top-center"
              toastClassName="custom-toast"
              bodyClassName="custom-toast-body"
              closeButton={false}
              autoClose={3000}
          />
        </div>
      ) : (
        <div className="app__loading">
          <Loader />
        </div>
      )}
    </>
  );
}

App.propTypes = {
  user: PropTypes.object,
  handleAdmin: PropTypes.func,
  handleAuth: PropTypes.func,
  admin: PropTypes.object,
  auth: PropTypes.object,
  items: PropTypes.object,
};
const mapStateToProps = (state) => ({
  user: state.auth,
  admin: state.admin,
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = (dispatch) => ({
  handleAdmin: (value) => {
    dispatch(updateAdmin(value));
  },
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
